import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://eekmegyvggirtnebrupv.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVla21lZ3l2Z2dpcnRuZWJydXB2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzIyNDc5NTEsImV4cCI6MTk4NzgyMzk1MX0.UvTHrwx92pXNJh0xs3KMDuuH7LMpysSBwPfymghIgXk"
export const supabase = createClient(supabaseUrl, supabaseAnonKey)